
















































import { Component, Vue } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'
import EditAppDialogBody from '@/apps/open/components/DialogBodys/weboffice/EditApp.vue'
import { getDocConversionApps, applyDocConversionApp, updateDocConversionApp } from '@/apps/open/services/doc_conversion'
import { TRANSFORM_DOC_URL } from '@/apps/open/constants'

interface DocTransAppInfo {
  developer_id?: number,
  app_id?: string | undefined,
  app_name: string,
  website: string,
  description: string
}

@Component({
  components: {
    Button
  }
})
export default class DocConversionApps extends Vue {
  apps: any = []
  activeIdx: number = -1

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  mounted () {
    this.initData()
    this.initEventListener()
  }

  beforeDestroy () {
    this.$eventBus.$clear('changeEnterprise', this.initData)
  }

  initEventListener () {
    this.$eventBus.$on('changeEnterprise', this.initData)
  }

  async initData () {
    const params = {
      developer_id: this.curEnterprise.developer_id
    }
    const res = await getDocConversionApps(params)
    if (res.status === 200 && res.data.data) {
      this.apps = res.data.data
    } else {
      this.apps = []
    }
  }

  jumpDevDoc () {
    window.open(TRANSFORM_DOC_URL)
  }

  showEditAppDialog (appInfo: any, index: number) {
    const isEdit: boolean = !!appInfo
    if (isEdit) this.activeIdx = index
    this.$dialog.show({
      title: isEdit ? '编辑应用' : '申请应用',
      body: EditAppDialogBody,
      bodyProps: {
        data: appInfo,
        submit: this.apply
      },
      buttons: [
        { text: '取消' },
        { text: '确定', type: 'primary', event: 'onOk' }
      ]
    })
  }

  get isPassed () {
    return this.$store.getters['User/isPassedDeveloper']
  }

  get hasApps () {
    return this.apps && this.apps.length > 0
  }

  async apply ({ app_id, app_name, description, website }: DocTransAppInfo) {
    const params: DocTransAppInfo = {
      app_name,
      description,
      website
    }
    try {
      const urlParams = { developer_id: this.curEnterprise.developer_id }
      if (app_id) {
        // update app information
        const res = await updateDocConversionApp(params, app_id, urlParams)
        this.apps.splice(this.activeIdx, 1, res.data)
      } else {
        // apply app
        const res = await applyDocConversionApp(params, urlParams)
        this.apps.push(res.data)
      }
      this.$message('申请已提交，请您耐心等待')
    } catch (error) {
      this.$message.error(error.message)
    } finally {
      this.$dialog.close()
    }
  }
}
